import { c as _c } from "react/compiler-runtime";
import { Button } from "@shared-components/shadcn/button";
import { Popover, PopoverContent, PopoverTrigger } from "@shared-components/shadcn/popover";
import { FlaskConical } from "lucide-react";
import { api } from "@shared-server/api";
import { featuresMap, type FeatureFlagType } from "@shared-utils/constants";
export const ActiveFeatureFlags = () => {
  const $ = _c(11);
  const activeFeatureFlags = api.feature.allEnabledForMe.useQuery();
  const t0 = activeFeatureFlags.data && activeFeatureFlags.data.length > 0 ? "hidden md:block" : "hidden";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button variant="ghost" className="group relative px-2"><FlaskConical size={22} strokeWidth={1.5} /><div className="absolute left-[18px] top-[12px] h-[4px] w-[4px] animate-[loader-ellipsis-with-idle_30s_0.0s_infinite_ease-in-out_both] rounded-full bg-blue-600 group-hover:animate-[loader-ellipsis_3.4s_0.0s_infinite_ease-in-out_both]" /><div className="absolute left-[22px] top-[8px] h-[5px] w-[5px] animate-[loader-ellipsis-with-idle_30s_0.4s_infinite_ease-in-out_both] rounded-full bg-yellow-600 group-hover:animate-[loader-ellipsis_3.4s_0.4s_infinite_ease-in-out_both]" /><div className="absolute left-[14px] top-[2px] h-[8px] w-[8px] animate-[loader-ellipsis-with-idle_30s_0.8s_infinite_ease-in-out_both] rounded-full bg-green-600 group-hover:animate-[loader-ellipsis_3.4s_0.8s_infinite_ease-in-out_both]" /></Button>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t0) {
    t2 = <PopoverTrigger asChild={true} className={t0}>{t1}</PopoverTrigger>;
    $[1] = t0;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <b>{"Experimental features:"}</b>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== activeFeatureFlags.data) {
    t4 = activeFeatureFlags.data?.map(_temp);
    $[4] = activeFeatureFlags.data;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <PopoverContent className="m-1"><div className="flex flex-col">{t3}<ul className="list-disc pl-5">{t4}</ul></div></PopoverContent>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <Popover>{t2}{t5}</Popover>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(flag) {
  return <li key={flag}><small>{featuresMap[flag]}</small></li>;
}